'use es6';

import { useRef } from 'react';
let uniqueId = 0;
const getUniqueId = () => uniqueId++;
export default function useComponentId() {
  const idRef = useRef(null);
  if (idRef.current === null) {
    idRef.current = getUniqueId();
  }
  return idRef.current;
}